export default function Logo({ size = 34, showWord = true, tone = "ink" }) {
  const inkFill = tone === "paper" ? "#FAF9F6" : "#0F172A";
  const wordColor = tone === "paper" ? "#FAF9F6" : "#0F172A";
  return (
    <div className="flex items-center gap-2.5 select-none" aria-label="Ronavirona">
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <rect x="10" y="12" width="14" height="40" rx="1.5" fill={inkFill} />
        <rect x="28" y="22" width="14" height="30" rx="1.5" fill="#D97706" />
        <rect x="46" y="32" width="8" height="20" rx="1.5" fill={inkFill} opacity="0.7" />
        <g fill={tone === "paper" ? "#0F172A" : "#FAF9F6"}>
          <circle cx="17" cy="18" r="1.1" />
          <circle cx="17" cy="24" r="1.1" />
          <circle cx="17" cy="30" r="1.1" />
          <circle cx="17" cy="36" r="1.1" />
          <circle cx="17" cy="42" r="1.1" />
          <circle cx="35" cy="28" r="1.1" />
          <circle cx="35" cy="34" r="1.1" />
          <circle cx="35" cy="40" r="1.1" />
        </g>
      </svg>
      {showWord && (
        <div className="leading-none">
          <div
            className="font-serif-display text-[1.2rem] tracking-tight"
            style={{ color: wordColor }}
          >
            Ronavirona
          </div>
          <div
            className="font-mono-mark text-[0.58rem] tracking-[0.32em] uppercase mt-0.5"
            style={{ color: tone === "paper" ? "rgba(250,249,246,0.6)" : "rgba(15,23,42,0.55)" }}
          >
            Buenos Aires
          </div>
        </div>
      )}
    </div>
  );
}
